import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom';

const NavButton = ({
    children,
    onClick = () => {}
}) => {
    return (
        <Nav.Item>
            <Nav.Link href='#' onClick={onClick}>{children}</Nav.Link>
        </Nav.Item>
    )
}

export default NavButton